import { Url } from '../shared/Url';
import Post from '../shared/Post';
import PostXlsUploadHist from '../shared/PostXlsUploadHist';
import { consultaUser } from './PefilFunction';
import { cookieData } from '../funciones/ConsultaUser';
import { requerido, numero, letras } from './Validaciones';

export const BusquedaEst = (string, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            strings: string
        }

        Post(`${Url}consultaEstHist`, Content, (resp) => {
            let data = JSON.parse(resp)
            let egresados = [];

            /* if (noinscritos === "")  */egresados = data[1];
            let regulares = data[0];
            let noinscritos = data[2];
            respuesta([regulares, egresados, noinscritos])
        });
    });
}

export const ConsultaAcademicosEst = (est, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            est: est
        }

        Post(`${Url}academicosEst`, Content, (resp) => {
            let data = JSON.parse(resp);
            let carreras = data[0];
            let materias = data[1];
            let carrACt = data[3];
            let semestres = data[2];
            let literales = data[4];

            let histCarreras = 0;
            /* Buscar si esta en las carreras la carrera actual */
            for (let i in carreras) {
                if (carrACt[0].id === carreras[i].id) histCarreras++
            }

            if (histCarreras === 0) carreras.push(carrACt[0])
            if (data[0].length === 0) carreras = carrACt

            respuesta([carreras, materias, semestres, literales])
        });
    });
}

export const ConsultaSemestres = (respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
        }

        Post(`${Url}consultSemestresCarrera`, Content, (resp) => {
            let data = JSON.parse(resp);
            let content = []
            for (let i in data[0]) {
                content.push (
                    { value: data[0][i].id, label: data[0][i].semestre_name, carrera: data[0][i].carrera_id, nombre: data[0][i].carrera_name, SemestreId: data[0][i].id }
                )
            }

            respuesta(content)
        });
    });
}

export const ConsultaMaterias = (est, semestre, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            est: est,
            semestre: semestre
        }

        Post(`${Url}consultMateriasHist`, Content, (resp) => {
            let data = JSON.parse(resp);
            let tipos = []
            let contTipos = data[1];
            for (let i in contTipos){
                tipos.push({
                    value: parseInt(contTipos[i].id), label: contTipos[i].tipoev_name 
                })
            }


            respuesta([data[0], tipos])
        });
    });
}

export const ConsultaMateriasApl = (est, semestre, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            est: est,
            semestre: semestre
        }

        Post(`${Url}consultMateriasHistApl`, Content, (resp) => {
            let data = JSON.parse(resp);

            let tipos = []
            let contTipos = data[1];
            for (let i in contTipos){
                tipos.push({
                    value: parseInt(contTipos[i].id), label: contTipos[i].tipoev_name 
                })
            }

            let MateApl = []
            let contMateApl = data[0];

            for (let i in contMateApl){
                MateApl.push({
                    value: parseInt(contMateApl[i][0].id_materia), label: contMateApl[i][0].materia_name, cuantitativo: contMateApl[i][0].cuantitativo
                })
            }
            respuesta([MateApl, tipos, data[2]])
        });
    });
}

export const AddNotaApl = (datos, est, respuesta) => {
    let mensaje = "Se ha agregado correctamente la asignatura al archivo histórico"
    let tipoMensaje = "info"

    /* Validaciones */
    if (datos.valorMa.value === "") {
        mensaje = "Selecciona una Materia para agregar el histórico"
        tipoMensaje = "error"
        respuesta([mensaje, tipoMensaje])
    }else if (datos.periodoSelect.value === "") {
        mensaje = "Indica el periodo de la materia"
        tipoMensaje = "error"
        respuesta([mensaje, tipoMensaje])
    }else if (datos.valorTe.value === "") {
        mensaje = "Selecciona el tipo de evaluación"
        tipoMensaje = "error"
        respuesta([mensaje, tipoMensaje])
    }else{
        let modalidad = "";
        
        /* Consultar modalidad */
        let Seccion = { id: datos.valorMa.value }
        Post(`${Url}ConsultaModalidadMat`, Seccion, (mod) => {
            let dataMod = JSON.parse(mod);
            modalidad = dataMod[0][0];
    
            if (modalidad.cualitativo === 1) cualitativo();
            if (modalidad.cuantitativo === 1) cuantitativo(modalidad.nota_max);
        });

        let cualitativo = () => {
            let notaL = datos.notaSelect.value;
            if (notaL === "") {
                mensaje = "Debes seleccionar una calificación literal para esta asignatura"
                tipoMensaje = "error"
                respuesta([mensaje, tipoMensaje])
            }else{
                cookieData((cookie) => {
                    let Content = {
                        uId: cookie[1],
                        est: est,
                        materia: datos.valorMa.value,
                        periodo: datos.periodoSelect.value,
                        te: datos.valorTe.value,
                        nota: notaL
                    }
            
                    Post(`${Url}addCalifHisApl`, Content, () => {
                        respuesta([mensaje, tipoMensaje])
                    });
                });
            }
        }
        
        let cuantitativo = (max) => {
            if (datos.nota === "") {
                mensaje = "Debes ingresar una calificación para esta asignatura"
                tipoMensaje = "error"
                respuesta([mensaje, tipoMensaje])
            }else{
                let nota = datos.nota;
        
                /* VALIDACIONES */
        
                if (!/^([0-9])*$/.test(nota)){
                    mensaje = "Debes colocar solo números para para esta asignatura"
                    tipoMensaje = "error"
                    respuesta([mensaje, tipoMensaje])
                }else{
                    if (nota > parseInt (max)) nota = max;

                    /* AÑADIR EL CERO AL LAS CALIFICACIONES MENORES DE 10 */
                    if (nota < 10 && nota > 0) nota = (`0${nota}`).substr(-2);
                    
                    if (nota === "0" || nota === "00" || nota === "000"){
                        nota = "";
                    }

                    cookieData((cookie) => {
                        let Content = {
                            uId: cookie[1],
                            est: est,
                            materia: datos.valorMa.value,
                            periodo: datos.periodoSelect.value,
                            te: datos.valorTe.value,
                            nota: nota
                        }
                
                        Post(`${Url}addCalifHisApl`, Content, () => {
                            respuesta([mensaje, tipoMensaje])
                        });
                    });
                }
            }
        }

    }

}

export const ConsultElectiva = (mat, est, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            est: est,
            materia: mat
        }

        Post(`${Url}consultElectivaSelect`, Content, (resp) => {
            let data = JSON.parse(resp);
            let contenido = { value:data[1].MatId , label: data[1].materia_name, id: data[1].HistId }


            let mes = (num) => {
                let meses = ["ENE", "FEB", "MAR", "ABR", "MAY", "JUN", "JUL", "AGO", "SEP", "OCT", "NOV", "DIC"]
                
                return meses[num - 1]
            }

            let periodo = {value: data[2].id, label: `${mes(data[2].corte_name)} ${data[2].corte_year}`}
            let te = {value: data[3].id, label: data[3].tipoev_name}

            respuesta([data[0], contenido, data[1].codigo, periodo, te, data[1].nota])
        });
    }); 
}

export const AgregarDatHistorico = (idEst, materia, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            est: idEst,
            materia: materia
        }

        Post(`${Url}addMateriasHist`, Content, (resp) => {
            let data = JSON.parse(resp);
            respuesta(data)
        });
    });
}

export const AgregarDatHistoricoElect = (idEst, materia, electiva, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            est: idEst,
            materia: materia.value,
            electiva: electiva
        }

        Post(`${Url}addMateriasHistElect`, Content, (resp) => {
            let data = JSON.parse(resp);

            let contenido = { value: materia.value, label: materia.label, id: data.IdReg }
            respuesta([data, contenido])
        });
    });
}

export const UpdMatElectiva = (materia, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            materia: materia.value,
            idHist: materia.id
        }

        Post(`${Url}updMateriasHistElect`, Content, (resp) => {
            let data = JSON.parse(resp);

            respuesta(data)
        });
    });
}

export const EliminarDatHistorico = (idEst, materia, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            est: idEst,
            materia: materia
        }

        Post(`${Url}delMateriasHist`, Content, (resp) => {
            let data = JSON.parse(resp);
            respuesta(data)
        });
    });
}

export const EliminarDatHistoricoApl = (materia, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            materia: materia
        }

        Post(`${Url}delMateriasHistApl`, Content, (resp) => {
            let data = JSON.parse(resp);
            respuesta(data)
        });
    });
}

export const AddItem = (campo, item, idEst, materia, respuesta) => {
    let status = {
        tipo: "error",
        mess: "El campo a acualizar no puede estar vacío",
        errores: 0
    }

    if (campo === "" || campo === null) status.errores ++;

    if (status.errores > 0) {
        respuesta(status)
    }else{
        cookieData((cookie) => {
            let Content = {
                uId: cookie[1],
                est: idEst,
                materia: materia,
                item: item,
                valor: campo
            }

            Post(`${Url}addHist`, Content, (resp) => {
                let data = JSON.parse(resp);

                if (data.status == "Error") {
                    status = {
                        tipo: "error",
                        mess: data.mess,
                        errores: 1
                    }
                }else{
                    status = {
                        tipo: "ok",
                        errores: 0
                    }
                }

                respuesta(status)
            });
        });
    }
}

export const ConsultTipEv = (actual, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
        }

        Post(`${Url}consultTe`, Content, (resp) => {
            let data = JSON.parse(resp);

            let tipos = []
            let contTipos = data[0];
            for (let i in contTipos){
                tipos.push({
                    value: parseInt(contTipos[i].id), label: contTipos[i].tipoev_name 
                })
            }

            let TeSelect = { value: actual.id, label: actual.tipoev_name } 
            respuesta ([tipos, TeSelect])
        });
    }); 
}

export const ConsultPeriodoHist = (id, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            id: id
        }

        Post(`${Url}consultPeriodo`, Content, (resp) => {
            let data = JSON.parse(resp);
            let mes = (num) => {
                let meses = ["ENE", "FEB", "MAR", "ABR", "MAY", "JUN", "JUL", "AGO", "SEP", "OCT", "NOV", "DIC"]
                
                return meses[num - 1]
            }

            let contenido = {value: data[0].id, label: `${mes(data[0].corte_name)} ${data[0].corte_year}`}
            let contenidoTe = {value: data[1][0].id, label: data[1][0].tipoev_name}
     
            respuesta([contenido, contenidoTe])
        });
    }); 
}

export const ConsultElectivas = (semestre, respuesta) => {
    let Content = {
        semestre: semestre
    }

    Post(`${Url}consultElectivas`, Content, (resp) => {
        let data = JSON.parse(resp);
        
        let contenido = [];

        for (let i in data[0]){
            contenido.push({
                value: data[0][i].id, label: data[0][i].materia_name
            })
        }
        respuesta(contenido)
    });
}

export const ConsultTipEvAlt = (respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
        }

        Post(`${Url}consultTe`, Content, (resp) => {
            let data = JSON.parse(resp);

            let tipos = []
            let contTipos = data[0];
            for (let i in contTipos){
                tipos.push({
                    value: parseInt(contTipos[i].id), label: contTipos[i].tipoev_name 
                })
            }

            respuesta (tipos)
        });
    }); 
}

export const GuardarNotaHist = (est, materia, nota, literal, respuesta) => {
    
    let errores = 0;
    let mensaje = {
        status: "",
        mensaje: ""
    };

    let icono = {
        icon: "fa fa-check",
        color: "#32704C" 
    }

    let modalidad = "";

    /* Consultar modalidad */

    let cualitativo = () => {
        let text = "";
        cookieData((cookie) => {
            let Content = {
                uId: cookie[1],
                est: est,
                materia: materia,
                literal: literal.value
            }
            
            Post(`${Url}updCalifHis`, Content, () => {
                respuesta([text, mensaje, icono])
            });
        });
    }

    let cuantitativo = (max) => {
        
        let text = nota;

        /* VALIDACIONES */

        if (!/^([0-9])*$/.test(nota)){
            mensaje = {
                status: "error",
                mensaje: "Debes colocar solo números para para esta asignatura"
            };
            text = "";
            nota = "";
            icono = {
                icon: "fa fa-times",
                color: "#A0555C" 
            };
            errores ++;
        }

        if (nota > parseInt (max)) text = max;

        /* AÑADIR EL CERO AL LAS CALIFICACIONES MENORES DE 10 */
        if (nota < 10 && nota > 0) text = (`0${nota}`).substr(-2);
        
        if (nota === "0" || nota === "00" || nota === "000"){
            text = "";
            nota = "";
        }

        if (errores === 0) {
            cookieData((cookie) => {
                let Content = {
                    uId: cookie[1],
                    est: est,
                    materia: materia,
                    nota: nota
                }
                
                Post(`${Url}updCalifHis`, Content, (resp) => {
                    respuesta([text, mensaje, icono])
                });
            });
        }else{
            respuesta([text, mensaje, icono])
        }
    }

    let Seccion = { id: materia }
    Post(`${Url}consultaModalidadHist`, Seccion, (mod) => {
        let dataMod = JSON.parse(mod);
        modalidad = dataMod[0][0];

        if (modalidad.cuantitativo === 1) cuantitativo(modalidad.nota_max);
        if (modalidad.cualitativo === 1) cualitativo();

    });
}

export const GuardarTeHist = (est, materia, valor, respuesta) => {
    let icono = {
        icon: "fa fa-check",
        color: "#32704C" 
    }

    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            est: est,
            materia: materia,
            valor: valor
        }
        Post(`${Url}updTeHis`, Content, (resp) => {
            respuesta(icono)
        });
    });
}

export const ConsultInscipcion = (est, materia, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            est: est,
            materia: materia,
        }

        Post(`${Url}chkInscripcion`, Content, (resp) => {
            let data = JSON.parse(resp);
            respuesta(data[0])
        });
    });


    respuesta(materia)
}

export const DeleteHist = (SemestreId, est, carrera, semestre, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            carrera: carrera,
            semestre: semestre,
            est: est,
            semId: SemestreId
        }

        Post(`${Url}delHistorico`, Content, (resp) => {
            let data = JSON.parse(resp);
            respuesta(data)
        });
    });
}

export const UploadXlsHist = (file, carrera, est, respuesta) => {
    cookieData((cookie) => {
        consultaUser ((usuario) => {
            let Content = {
                uId: cookie[1],
                file: file,
                carrera: carrera.carrera_name,
                est: est,
                usuario: usuario
            }
            
            PostXlsUploadHist(`${Url}uploadCalifXlsHist`, Content, (resp) => {
                let data = JSON.parse(resp);
                respuesta(data)
            });
        });
    });
}

export const ConsultaCeldas = (respuesta) => {
    Post(`${Url}consultCeldas`, "", (resp) => {
        let data = JSON.parse(resp);
        respuesta(data[0])
    });
}

export const GuardarCeldas = (campos, respuesta) => {
    let errores = 0;
    let nameErr = [];
    let states = [];

    let mensaje = [{
        status: "error",
        mensaje: "No se pudo guardar la información. Revisa los errores encontrados para continuar"
    }];

    /* Validaciones */
    requerido(errores, campos.celCed, "", "", "", "Debes definir la celda de la Cédula", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    requerido(errores, campos.celCarr, "", "", "", "Debes definir la celda de la Carrera", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    requerido(errores, campos.fila1, "", "", "", "Debes definir el número de la primera fila del histórico", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    requerido(errores, campos.may, "", "", "", "Debes definir la columna MAY", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    requerido(errores, campos.jun, "", "", "", "Debes definir la columna JUN", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    requerido(errores, campos.ago, "", "", "", "Debes definir la columna AGO", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    requerido(errores, campos.codigo, "", "", "", "Debes definir la columna CÓDIGO", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    requerido(errores, campos.sa, "", "", "", "Debes definir la columna S.A.", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    requerido(errores, campos.nota, "", "", "", "Debes definir la columna NOTA", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    requerido(errores, campos.hoja, "", "", "", "Debes definir el nombre de la HOJA a seleccionar", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    numero(errores, campos.fila1, "", "", "El campo Primera Fila del Histórico debe contener solo números", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    letras(errores, campos.may, "", "", "El campo MAY debe contener solo letras", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    letras(errores, campos.jun, "", "", "El campo JUN debe contener solo letras", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    letras(errores, campos.ago, "", "", "El campo AGO debe contener solo letras", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    letras(errores, campos.codigo, "", "", "El campo CÓDIGO debe contener solo letras", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    letras(errores, campos.sa, "", "", "El campo S.A. debe contener solo letras", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    letras(errores, campos.nota, "", "", "El campo NOTA debe contener solo letras", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    if (errores === 0){
        cookieData((cookie) => {
            let Content = {
                uId: cookie[1],
                campos: campos
            }
    
            Post(`${Url}updCeldas`, Content, () => {
                mensaje = [{
                    status: "info",
                    mensaje: "Se ha actualizaron correctamente los campos"
                }];

                respuesta([states, mensaje, errores, nameErr])
            });
        });
    }else{
        respuesta([states, mensaje, errores, nameErr])
    }
}

export const ConsultLiterales = (respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1]
        }

        Post(`${Url}consultLiterales`, Content, (resp) => {
            let data = JSON.parse(resp);
            let contenido = []

            contenido.push({
                value: "", label: "- SELECCIONA -", aprueba: ""
            })
            
            for (let i in data[0]){
                contenido.push(
                    { value: data[0][i].id, label: data[0][i].literal, aprueba: data[0][i].aprueba }
                )
            }

            respuesta(contenido)
        });
    });
}


// WEBPACK FOOTER //
// ./src/funciones/HistoricoFunction.jsx